//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CompanyDrawer from "./modules/CompanyDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { downloadFile } from '@/api/manage';
export default {
  name: 'CompanyList',
  mixins: [JeecgListMixin],
  components: {
    CompanyDrawer: CompanyDrawer
  },
  data: function data() {
    return {
      pagePath: '/site/company',
      pageTitle: '企业信息',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'companyName',
        colName: 'company_name',
        title: '企业全称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'companyCode',
        colName: 'company_code',
        title: '组织机构代码',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'creditCode',
        colName: 'credit_code',
        title: '统一社会信用代码',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'type_dictText',
        colName: 'type',
        title: '企业类别',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'industry',
        colName: 'industry',
        title: '所属行业',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'address',
        colName: 'address',
        title: '详细地址',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'legalPerson',
        colName: 'legal_person',
        title: '法人代表',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'website',
        colName: 'website',
        title: '官网',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'contact',
        colName: 'contact',
        title: '联系人',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'contactTel',
        colName: 'contact_tel',
        title: '联系人电话',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'sDate',
        colName: 's_date',
        title: '成立日期',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'businessTerm',
        colName: 'business_term',
        title: '营业期限',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  computed: {},
  methods: {
    onDateSDate: function onDateSDate(value, dateArray) {
      this.queryParam.sDateStart = dateArray[0];
      this.queryParam.sDateEnd = dateArray[1];
    },
    //  导出模板
    handleExportTemplate: function handleExportTemplate(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = this.pageTitle + '导出文件模板';
      }

      var url = '/site/company/exportXlsTemplate';
      downloadFile(fileName + '.xls', url);
    }
  }
};